import React, {useState} from 'react'

const BarcodeSheetRecordContext = React.createContext(null)

function BarcodeSheetRecordContextProvider(props) {
  // [A]
  const [barcodeSheetRecord, setBarcodeSheetRecord] = useState('')

  const value = {
    setBarcodeSheetRecord,
    barcodeSheetRecord,
  }

  // [B]
  return (
    <BarcodeSheetRecordContext.Provider value={value}>
      {props.children}
    </BarcodeSheetRecordContext.Provider>
  )
}

const BarcodeSheetRecordContextConsumer = BarcodeSheetRecordContext.Consumer

export {
  BarcodeSheetRecordContext,
  BarcodeSheetRecordContextProvider,
  BarcodeSheetRecordContextConsumer,
}
